import React from 'react'
import Logo56 from '../assets/56/logo.png'
import Logo57 from '../assets/57/logo.png'
import Logo58 from '../assets/58/logo.png'
import Logo61 from '../assets/61/logo.png'
import Logo62 from '../assets/62/logo.png'

const Logo = (props) => {

  return (
    <>
      {parseInt(process.env.REACT_APP_PROJECTID) === 56 ? <img src={Logo56} style={{ maxWidth: '200px', marginTop: '25px' }} alt="logo" /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 57 ? <img src={Logo57} style={{ maxWidth: '200px', marginTop: '25px' }} alt="logo" /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 58 ? <img src={Logo58} style={{ maxWidth: '200px', marginTop: '25px' }} alt="logo" /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 61 ? <img src={Logo61} style={{ maxWidth: '200px', marginTop: '25px' }} alt="logo" /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 62 ? <img src={Logo62} style={{ maxWidth: '200px', marginTop: '25px' }} alt="logo" /> : null }
    </>
  )
}

export default Logo
